import { AdditiveBlending, DoubleSide, MeshBasicMaterial } from 'three';

import type { CutoutInfo } from '../types';

/**
 * `userData.type` of the proxy mesh standing in for a vent. The opening itself is subtracted
 * geometry, so the proxy is the only thing a pointer or a bounding box can find a vent by.
 */
export const VENT_CUTOUT_TYPE = 'vent-cutout';

/** Same blue as the engine's category and hover glow. */
const VENT_GLOW_COLOR = 0xa8dcff;

/** A vent is the one cutout cut surround-only -- it sits under the slab and must not punch the worktop. */
export const isVentCutout = (cutout: CutoutInfo): boolean => cutout.surroundOnly === true;

/**
 * Light added into the slots rather than a surface painted across them: additive, part transparent
 * and writing no depth, so switching the proxy on reads as the hole glowing instead of a plug
 * filling it. Unlit on purpose -- the glow marks a thing the viewer can click, not a lit surface.
 */
export const createVentProxyMaterial = (): MeshBasicMaterial => new MeshBasicMaterial({
	color: VENT_GLOW_COLOR,
	transparent: true,
	opacity: 0.45,
	blending: AdditiveBlending,
	depthWrite: false,
	side: DoubleSide,
	toneMapped: false
});
